export const NEVER_SHOW = 'never-show-enable-notifications'
export const HIDE_INTEGRATION_NOTICE = 'hide-integration-notice'


// WEBPACK FOOTER //
// ./src/scripts/components/GlobalNotificationBar/constants.js